module.exports = __webpack_public_path__ + "static/media/marieZepf00.361a7d14.png";